import FleetSvg from '@/assets/svg/products/FleetSvg';
// import image from '@/assets/imgs/image.png';
import Branch from '@/assets/svg/products/Branch';
import Bill from '@/assets/svg/products/Bill';
import Reports from '@/assets/svg/products/Reports';
import Financial from '@/assets/svg/products/Financial';
import Contract from '@/assets/svg/products/Contract';
import Maintance from '@/assets/svg/products/Maintance';
import Reservation from '@/assets/svg/products/Reservation';

import Frame1 from '@/assets/svg/products/Frame1';
import Fleet_Management from '@/assets/svg/products/Fleet_Management';
import Loyalty from '@/assets/svg/products/Loyalty';
import Employe from '@/assets/svg/products/Employe';
import Branches from '@/assets/svg/products/Branches';
import ServicesManagement from '@/assets/svg/products/ServicesManagement';
import DocumentManagement from '@/assets/svg/products/DocumentManagement';
import BillingManagement from '@/assets/svg/products/BillingManagement';
import ReportsStatistics from '@/assets/svg/products/ReportsStatistics';
import Frame from '@/assets/svg/products/Frame';
import Carsvg from '@/features/products/components/svg/Car';

import {
    UserCheck,
    Headphones,
    Gift,
    Mail,
    Database,
    Users,
    Bell,
    LayoutDashboard,
    BarChart3,
    Megaphone,
    Inbox,
    UserPlus,
    FileText,
    Clock,
    CalendarDays,
    DollarSign,
    Plane,
    TrendingUp,
    Car,
    MapPin,
    Shield,
    Camera,
    Calendar,
    CreditCard,
    Edit,
    Building2,
    Wallet,
    Archive,
    CheckCircle,
    Wrench,
    AlertTriangle,
    Package,
    Receipt,
    BanknoteIcon,
    FileCheck,
    Download,
    type LucideIcon,
} from 'lucide-react';
import Crm from '@/assets/svg/products/Crm1';
import Hrm from '@/features/products/components/svg/Hrm';
import MedicalPrescription from '@/features/products/components/clinico/svg/Medical_prescription';
import Clinco from '@/features/products/components/clinico/svg/Clinco';
import MapIcon from '@/assets/svg/products/Map';
import Documents from '@/assets/svg/products/Documents';
import DigitalFinance from '@/assets/svg/products/DigitalFinance';
import DocumentAnalytics from '@/assets/svg/products/DocumentAnalytics';
import ReportsAnalysis from '@/assets/svg/products/ReportsAnalysis';
import type { ComponentType } from 'react';
import { Fmsreviews, reviews } from '@/features/products/data/configs.data';

export type ProductAdvantage = {
    textKey: string;
    icon: LucideIcon;
};

export type Product = {
    id: number;
    /** Clean SEO slug used in `/products/:slug` URLs. */
    slug: string;
    img: { img: string }[] | ComponentType<{ className?: string }>;
    advantages: ProductAdvantage[];
    background?: ComponentType<{ className?: string }>;
    cardSvg?: ComponentType;
    svg?: ComponentType<{ className?: string }>;
    /** When true, hero prefers `products.{id}.subtitle` over `mainDescription` */
    hasSubtitle?: boolean;
};

export const products: Product[] = [
    {
        id: 1,
        slug: 'customer-management',
        img: reviews,
        advantages: [
            { textKey: 'products.1.advantages.0', icon: UserCheck },
            { textKey: 'products.1.advantages.1', icon: Headphones },
            { textKey: 'products.1.advantages.2', icon: Gift },
            { textKey: 'products.1.advantages.3', icon: Headphones },
            { textKey: 'products.1.advantages.4', icon: Mail },
            { textKey: 'products.1.advantages.5', icon: Database },
            { textKey: 'products.1.advantages.6', icon: Users },
            { textKey: 'products.1.advantages.7', icon: Bell },
            { textKey: 'products.1.advantages.8', icon: LayoutDashboard },
            { textKey: 'products.1.advantages.9', icon: BarChart3 },
            { textKey: 'products.1.advantages.10', icon: Megaphone },
            { textKey: 'products.1.advantages.11', icon: Inbox },
        ],
        background: Crm,
        cardSvg: Employe,
    },
    {
        id: 2,
        slug: 'human-resources',
        img: reviews,
        advantages: [
            { textKey: 'products.2.advantages.0', icon: Users },
            { textKey: 'products.2.advantages.1', icon: FileText },
            { textKey: 'products.2.advantages.2', icon: Clock },
            { textKey: 'products.2.advantages.3', icon: CalendarDays },
            { textKey: 'products.2.advantages.4', icon: DollarSign },
            { textKey: 'products.2.advantages.5', icon: Plane },
            { textKey: 'products.2.advantages.6', icon: TrendingUp },
            { textKey: 'products.2.advantages.7', icon: UserPlus },
        ],
        background: Loyalty,
        cardSvg: Loyalty,
        svg: Hrm,
    },
    {
        id: 3,
        slug: 'fleet-management',
        img: reviews,
        advantages: [
            { textKey: 'products.3.advantages.0', icon: Car },
            { textKey: 'products.3.advantages.1', icon: MapPin },
            { textKey: 'products.3.advantages.2', icon: BarChart3 },
            { textKey: 'products.3.advantages.3', icon: Shield },
            { textKey: 'products.3.advantages.4', icon: Camera },
        ],
        background: FleetSvg,
        cardSvg: Fleet_Management,
        svg: Carsvg,
        hasSubtitle: true,
    },
    {
        id: 4,
        slug: 'reservations',
        img: reviews,
        advantages: [
            { textKey: 'products.4.advantages.0', icon: Calendar },
            { textKey: 'products.4.advantages.1', icon: DollarSign },
            { textKey: 'products.4.advantages.2', icon: CalendarDays },
            { textKey: 'products.4.advantages.3', icon: Building2 },
            { textKey: 'products.4.advantages.4', icon: Mail },
            { textKey: 'products.4.advantages.5', icon: Edit },
        ],
        background: Reservation,
        cardSvg: Frame,
    },
    {
        id: 5,
        slug: 'branches',
        img: reviews,
        advantages: [
            { textKey: 'products.5.advantages.0', icon: Receipt },
            { textKey: 'products.5.advantages.1', icon: CreditCard },
            { textKey: 'products.5.advantages.2', icon: Wallet },
            { textKey: 'products.5.advantages.3', icon: Archive },
            { textKey: 'products.5.advantages.4', icon: Database },
            { textKey: 'products.5.advantages.5', icon: CheckCircle },
        ],
        background: Branch,
        cardSvg: Branches,
        svg: MapIcon,
    },
    {
        id: 6,
        slug: 'maintenance',
        img: reviews,
        advantages: [
            { textKey: 'products.6.advantages.0', icon: MapPin },
            { textKey: 'products.6.advantages.1', icon: Building2 },
            { textKey: 'products.6.advantages.2', icon: Wrench },
            { textKey: 'products.6.advantages.3', icon: Receipt },
            { textKey: 'products.6.advantages.4', icon: FileText },
            { textKey: 'products.6.advantages.5', icon: Bell },
            { textKey: 'products.6.advantages.6', icon: BarChart3 },
            { textKey: 'products.6.advantages.7', icon: Package },
        ],
        background: Maintance,
        cardSvg: ServicesManagement,
        hasSubtitle: true,
    },
    {
        id: 7,
        slug: 'contracts',
        img: reviews,
        advantages: [
            { textKey: 'products.7.advantages.0', icon: MapPin },
            { textKey: 'products.7.advantages.1', icon: Building2 },
            { textKey: 'products.7.advantages.2', icon: Wrench },
            { textKey: 'products.7.advantages.3', icon: Receipt },
            { textKey: 'products.7.advantages.4', icon: FileText },
            { textKey: 'products.7.advantages.5', icon: AlertTriangle },
            { textKey: 'products.7.advantages.6', icon: TrendingUp },
            { textKey: 'products.7.advantages.7', icon: Package },
        ],
        background: Contract,
        cardSvg: DocumentManagement,
        svg: Documents,
        hasSubtitle: true,
    },
    {
        id: 8,
        slug: 'financial-system',
        img: Fmsreviews,
        advantages: [
            { textKey: 'products.8.advantages.0', icon: Receipt },
            { textKey: 'products.8.advantages.1', icon: BarChart3 },
            { textKey: 'products.8.advantages.2', icon: FileCheck },
            { textKey: 'products.8.advantages.3', icon: BanknoteIcon },
            { textKey: 'products.8.advantages.4', icon: Bell },
            { textKey: 'products.8.advantages.5', icon: Building2 },
        ],
        background: Financial,
        cardSvg: Frame1,
        svg: DigitalFinance,
    },
    {
        id: 9,
        slug: 'invoicing',
        img: reviews,
        advantages: [
            { textKey: 'products.9.advantages.0', icon: Receipt },
            { textKey: 'products.9.advantages.1', icon: CreditCard },
            { textKey: 'products.9.advantages.2', icon: Wallet },
            { textKey: 'products.9.advantages.3', icon: Database },
        ],
        background: Bill,
        cardSvg: BillingManagement,
        svg: DocumentAnalytics,
        hasSubtitle: true,
    },
    {
        id: 10,
        slug: 'reports',
        img: reviews,
        advantages: [
            { textKey: 'products.10.advantages.0', icon: LayoutDashboard },
            { textKey: 'products.10.advantages.1', icon: TrendingUp },
            { textKey: 'products.10.advantages.2', icon: BarChart3 },
            { textKey: 'products.10.advantages.3', icon: Download },
            { textKey: 'products.10.advantages.4', icon: DollarSign },
            { textKey: 'products.10.advantages.5', icon: Car },
            { textKey: 'products.10.advantages.6', icon: Users },
        ],
        background: Reports,
        cardSvg: ReportsStatistics,
        svg: ReportsAnalysis,
    },
    {
        id: 11,
        slug: 'clinic-management',
        img: MedicalPrescription,
        advantages: [
            { textKey: 'products.11.advantages.0', icon: LayoutDashboard },
            { textKey: 'products.11.advantages.1', icon: TrendingUp },
            { textKey: 'products.11.advantages.2', icon: BarChart3 },
            { textKey: 'products.11.advantages.3', icon: Users },
        ],
        cardSvg: Clinco,
        background: Clinco,
        svg: Clinco,
    },
];

export function getProductByParam(param?: string): Product | undefined {
    if (!param) return undefined;
    const bySlug = products.find((product) => product.slug === param);
    if (bySlug) return bySlug;

    const numericId = Number(param);
    if (Number.isInteger(numericId) && numericId > 0) {
        return products.find((product) => product.id === numericId);
    }

    return undefined;
}

export function getProductPath(product: Pick<Product, 'slug'>): string {
    return `/products/${product.slug}`;
}
